import * as Sentry from '@sentry/react'
import {isSentryEnabled} from './sentry'

export type BreadcrumbLevel = 'fatal' | 'error' | 'warning' | 'info' | 'debug'

export const addBreadcrumb = (
  category: string,
  message: string,
  level: BreadcrumbLevel = 'info',
  data?: Record<string, unknown>,
): void => {
  if (!isSentryEnabled()) return
  Sentry.addBreadcrumb({category, message, level, data, timestamp: Date.now() / 1000})
}
